import { Component, OnInit, ViewChild } from '@angular/core';
import { Classificacao } from '../models/classificacao';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MatPaginator, MatDialog, PageEvent } from '@angular/material';
import { CarregandoService } from '../services/carregando.service';
import { UtilitarioService } from '../services/utilitario.service';
import { NotificacaoService } from '../services/notificacao.service';
import { SegmentacaoService } from '../services/segmentacao.service';
import swal from 'sweetalert2';
import { CadastrarClassificacaoModalComponent } from '../modals/classificacao-modal/cadastrar-classificacao-modal/cadastrar-classificacao-modal.component';
import { Segmentacao } from '../models/segmentacao';
import { PaginatorService } from '../services/paginator.service';

declare const $: any;

@Component({
  selector: 'app-classificacao-integrador',
  templateUrl: './classificacao-integrador.component.html',
  styleUrls: ['./classificacao-integrador.component.scss']
})
export class ClassificacaoIntegradorComponent implements OnInit {

  classificacoesFiltrados: Segmentacao[] = [];
  carregando = true;
  campoOrdenacao = 'descricao';
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  public config: PerfectScrollbarConfigInterface = {};

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(
    private carregandoService: CarregandoService,
    public utilitarioService: UtilitarioService,
    private notificacaoService: NotificacaoService,
    public dialog: MatDialog,
    private segmentacaoService: SegmentacaoService,
    private paginatorService: PaginatorService) { }

  ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarClassificacao();
  }

  buscarClassificacao() {
    this.carregandoService.mostra('buscarClassificacao');

    this.segmentacaoService.consultarComPaginacao(this.paginacao.paginaAtual, this.itensPorPagina, this.campoOrdenacao, (this.ordenarDesc ? 'desc' : 'asc')).subscribe((data: any) => {
      this.classificacoesFiltrados = data.itens;

      if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
        this.itensPorPagina = 10;
      }

      this.paginacao.total = data.total;

      this.carregando = false;
      this.carregandoService.esconde('buscarClassificacao');
    }, (erro) => {
      this.carregandoService.esconde('buscarClassificacao');
      this.notificacaoService.erro(erro);
    });
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarClassificacao();
  }

  excluirItem(idClass) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir a Classificação?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluirItem');
        this.segmentacaoService.excluir(idClass).subscribe(resp => {
          this.notificacaoService.sucesso('Ponto excluído com sucesso!!!');
          this.carregandoService.esconde('excluirItem');
          this.buscarClassificacao();

        }, (erro) => {
          this.carregandoService.esconde('excluirItem');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  novoItem() {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(CadastrarClassificacaoModalComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: {},
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: Segmentacao) => {
      if (result) {
        this.buscarClassificacao();
      }
    });
  }

  editarItem(idClass) {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(CadastrarClassificacaoModalComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: { idClassificacao: idClass },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: Segmentacao) => {
      if (result) {
        this.buscarClassificacao();
      }
    });
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }
}